module.exports = __webpack_public_path__ + "static/media/acai.e87072d1.png";